interface WorldWithRingSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WorldWithRingSVG = ({ color, style }: WorldWithRingSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="52"
    viewBox="0 0 55 52"
    fill="none"
  >
    <g clipPath="url(#clip0_767_3069)">
      <path
        d="M27.2501 11.097C35.4142 11.097 42.0325 17.7153 42.0325 25.8794C42.0325 34.0435 35.4142 40.6619 27.2501 40.6619C19.086 40.6619 12.4677 34.0435 12.4677 25.8794C12.4677 17.7153 19.086 11.097 27.2501 11.097Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.2501 40.6592C23.8718 40.6592 21.1305 34.0421 21.1305 25.8767C21.1305 17.7114 23.8692 11.0943 27.2501 11.0943C30.631 11.0943 33.3697 17.7114 33.3697 25.8767C33.3697 29.8947 32.7047 33.5395 31.6285 36.2046"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3358 30.4961H37.8699"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3358 21.3308H37.8699"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.04587 23.4377C4.37758 23.4377 5.45715 24.5173 5.45715 25.849C5.45715 27.1807 4.37758 28.2603 3.04587 28.2603C1.71415 28.2603 0.634583 27.1807 0.634583 25.849C0.634583 24.5173 1.71415 23.4377 3.04587 23.4377Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60702 37.5248C8.93874 37.5248 10.0183 38.6044 10.0183 39.9361C10.0183 41.2678 8.93874 42.3474 7.60702 42.3474C6.27531 42.3474 5.19574 41.2678 5.19574 39.9361C5.19574 38.6044 6.27531 37.5248 7.60702 37.5248Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.2843 23.4377C52.616 23.4377 53.6956 24.5173 53.6956 25.849C53.6956 27.1807 52.616 28.2603 51.2843 28.2603C49.9526 28.2603 48.873 27.1807 48.873 25.849C48.873 24.5173 49.9526 23.4377 51.2843 23.4377Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.7257 37.5248C48.0574 37.5248 49.137 38.6044 49.137 39.9361C49.137 41.2678 48.0574 42.3474 46.7257 42.3474C45.394 42.3474 44.3144 41.2678 44.3144 39.9361C44.3144 38.6044 45.394 37.5248 46.7257 37.5248Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60702 9.14764C8.93874 9.14764 10.0183 10.2272 10.0183 11.5589C10.0183 12.8906 8.93874 13.9702 7.60702 13.9702C6.27531 13.9702 5.19574 12.8906 5.19574 11.5589C5.19574 10.2272 6.27531 9.14764 7.60702 9.14764Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.7257 9.14764C48.0574 9.14764 49.137 10.2272 49.137 11.5589C49.137 12.8906 48.0574 13.9702 46.7257 13.9702C45.394 13.9702 44.3144 12.8906 44.3144 11.5589C44.3144 10.2272 45.394 9.14764 46.7257 9.14764Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7675 46.5429C21.0992 46.5429 22.1788 47.6225 22.1788 48.9542C22.1788 50.2859 21.0992 51.3655 19.7675 51.3655C18.4358 51.3655 17.3562 50.2859 17.3562 48.9542C17.3562 47.6225 18.4358 46.5429 19.7675 46.5429Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8672 46.5429C36.1989 46.5429 37.2785 47.6225 37.2785 48.9542C37.2785 50.2859 36.1989 51.3655 34.8672 51.3655C33.5355 51.3655 32.4559 50.2859 32.4559 48.9542C32.4559 47.6225 33.5355 46.5429 34.8672 46.5429Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7675 0.634461C21.0992 0.634461 22.1788 1.71403 22.1788 3.04575C22.1788 4.37746 21.0992 5.45703 19.7675 5.45703C18.4358 5.45703 17.3562 4.37746 17.3562 3.04575C17.3562 1.71403 18.4358 0.634461 19.7675 0.634461Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8672 0.634461C36.1989 0.634461 37.2785 1.71403 37.2785 3.04575C37.2785 4.37746 36.1989 5.45703 34.8672 5.45703C33.5355 5.45703 32.4559 4.37746 32.4559 3.04575C32.4559 1.71403 33.5355 0.634461 34.8672 0.634461Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.7687 41.5479L40.2761 44.812"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.6624 28.1865L47.5811 37.6743"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.543 13.9502L50.5888 23.3237"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1084 4.62727L44.6596 10.1123"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1991 2.89355H28.8035"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81525 10.1426L17.5999 4.48494"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.94693 23.2551L7.00038 13.8613"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.74149 37.0779L4.99268 31.6969"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5415 47.2102L9.65533 41.4815"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3088 48.8452H22.2753"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_767_3069">
        <rect
          width="54.3301"
          height="52"
          fill={color}
          transform="matrix(1 0 0 -1 0 52)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default WorldWithRingSVG;
